import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WebSocketState, Telemetry } from '../../types';

const initialState: WebSocketState = {
  isConnected: false,
  robotsOnline: [],
  telemetry: {},
  subscribedRobots: [],
  lastCommandAck: undefined,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setConnected: (state, action: PayloadAction<boolean>) => { state.isConnected = action.payload; },
    setRobotsOnline: (state, action: PayloadAction<string[]>) => { state.robotsOnline = action.payload; },
    addRobotOnline: (state, action: PayloadAction<string>) => {
      if (!state.robotsOnline.includes(action.payload)) state.robotsOnline.push(action.payload);
    },
    removeRobotOnline: (state, action: PayloadAction<string>) => {
      state.robotsOnline = state.robotsOnline.filter((s) => s !== action.payload);
    },
    setTelemetry: (state, action: PayloadAction<Telemetry>) => {
      const serial = action.payload.robot_serial;
      state.telemetry[serial] = action.payload;
      // Also mark robot as online when we receive telemetry
      if (serial && !state.robotsOnline.includes(serial)) {
        state.robotsOnline.push(serial);
      }
    },
    setCommandAck: (state, action: PayloadAction<{ command_id: string; status: string }>) => {
      state.lastCommandAck = action.payload;
    },
    addSubscribedRobot: (state, action: PayloadAction<string>) => {
      if (!state.subscribedRobots.includes(action.payload)) state.subscribedRobots.push(action.payload);
    },
    removeSubscribedRobot: (state, action: PayloadAction<string>) => {
      state.subscribedRobots = state.subscribedRobots.filter((s) => s !== action.payload);
    },
    clearRobotTelemetry: (state, action: PayloadAction<string>) => {
      delete state.telemetry[action.payload];
    },
  },
});

export const {
  setConnected, setRobotsOnline, addRobotOnline, removeRobotOnline,
  setTelemetry, setCommandAck, addSubscribedRobot, removeSubscribedRobot, clearRobotTelemetry,
} = websocketSlice.actions;
export default websocketSlice.reducer;
